import React, { useEffect, useState } from 'react'
import styles from './SingleWorkTableCreateModal.module.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import FormDateSelector from 'components/UI/AsideModal/Form/FormDateSelector'
import { observer } from 'mobx-react'
import DatePicker from 'react-datepicker'
import { timeConverter } from 'components/ContentBox/Online-schedule/components/functions'
import { addZero } from 'helpers/math'
import { superAxiosRequest } from 'axiosApi'
import 'react-datepicker/dist/react-datepicker.css'
import FormInput from '../../../../UI/AsideModal/Form/FormInput'

const SingleWorkTableCreateModal = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  const [locations, setLocations] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: 'db/locations',
    })
      .then(({ data }) => {
        if (data && data.result) {
          setLocations(
            data.result.map((item) => ({
              label: item.name,
              value: item.id,
            })),
          )
        }
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  const handleDateChange = (val) => {
    changeValues(val, 'date')
  }

  return (
    <div className={styles.groupForm}>
      <FormField>
        <FormLabel isRequired>Дата:</FormLabel>
        <FormDateSelector
          placeholder='Выберите дату'
          onChange={handleDateChange}
          value={modalValue?.date || ''}
          error={check('date')}
        />
      </FormField>

      <FormField>
        <FormLabel isRequired>Время прихода:</FormLabel>
        <FormInput>
          <DatePicker
            selected={
              modalValue?.start_at
                ? new Date('2020-01-01T' + modalValue.start_at)
                : new Date('2020-01-01T08:00:00')
            }
            onChange={(date) => {
              if (date) {
                changeValues(
                  timeConverter(date, 'time') +
                    `:${addZero(date.getSeconds())}`,
                  'start_at',
                )
              }
            }}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={15}
            timeCaption='Время'
            timeFormat='HH:mm'
            dateFormat='HH:mm'
            placeholderText='Выберите время'
          />
        </FormInput>
      </FormField>

      <FormField>
        <FormLabel isRequired>Локация:</FormLabel>
        <SelectCustom
          placeholder='Выберите локацию'
          options={locations}
          sortKey='label'
          valueID={modalValue?.in_location_id}
          onChange={(option) => changeValues(option.value, 'in_location_id')}
          isSearchable
          isDisabled={isLoading}
          error={check('in_location_id')}
        />
      </FormField>

      <FormField>
        <FormLabel>Широта (необязательно):</FormLabel>
        <FormInput>
          <input
            type='number'
            step='any'
            value={modalValue?.in_latitude || ''}
            onChange={(e) => changeValues(e.target.value, 'in_latitude')}
            placeholder='Введите широту'
          />
        </FormInput>
      </FormField>

      <FormField>
        <FormLabel>Долгота (необязательно):</FormLabel>
        <FormInput>
          <input
            type='number'
            step='any'
            value={modalValue?.in_longitude || ''}
            onChange={(e) => changeValues(e.target.value, 'in_longitude')}
            placeholder='Введите долготу'
          />
        </FormInput>
      </FormField>
    </div>
  )
}

export default observer(SingleWorkTableCreateModal)
